import { FC, useState, useEffect } from 'react';
import { Grid, Typography } from '@mui/material';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import { useTranslation } from 'react-i18next';
import { SCUIButton } from '../../../../../atomic/atoms';
import { BillingQuery } from '../../../../../services/query';
import Swal from 'sweetalert2';
import { ReturnCommand } from '../../../../../services/command';

export const RefundPrepareSellerReturnShipment: FC<{
    customerId?: any;
    irsaliyeFaturaSeriNo?: any;
    shippingListId?: any;
    returnId?: any;
    atDrawer?: any;
}> = ({ atDrawer, customerId, irsaliyeFaturaSeriNo, shippingListId, returnId }) => {
    const { t } = useTranslation();
    const other_link: any = import.meta.env.VITE_APPURL!;

    const [isPrintEnabled, setIsPrintEnabled] = useState<boolean>(!!irsaliyeFaturaSeriNo);
    const [isCreateEnabled, setIsCreateEnabled] = useState<boolean>(!irsaliyeFaturaSeriNo);
    const [documentNo, setDocumentNo] = useState<string>('');
    const getDocumentNo = () => {
        let params = { returnId: returnId, shipmentId: shippingListId };
        ReturnCommand.GetReturnDispatchDocumentNo(params).then((res: any) => {
            if (res.data.documentNo) {
                setDocumentNo(res.data.documentNo);
                setIsPrintEnabled(true);
                setIsCreateEnabled(false);
            }

            if (!res.data.documentNo) {
                setIsCreateEnabled(true);
                setIsPrintEnabled(false);
            }
        });
    };
    useEffect(() => {
        getDocumentNo();
    }, []);
    const printEInvoice = async () => {
        let params = {
            documentNo: documentNo,
            referenceId: shippingListId,
            customerId: customerId,
        };
        BillingQuery.GetEDispatch(params).catch((error: any) => {
            Swal.fire(t('refund.dispatchNoteError'), t('refund.errorQueue'), 'error');
            console.log('Hata :>> ', error);
        });
    };
    const createPdfBlobUrl = (base64String: string): string => {
        const byteCharacters = atob(base64String);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });

        return URL.createObjectURL(blob);
    };
    const label = () => {
        let params = { returnId: returnId, shippingListId: shippingListId };
        ReturnCommand.GetMPReturnCargoLabelPdf(params)
            .then((res: any) => {
                openPdfFromBase64(res);
                window.location.reload();
            })
            .finally(() => {});
    };
    const openPdfFromBase64 = (base64String: string) => {
        const pdfBlobUrl = createPdfBlobUrl(base64String);
        window.open(pdfBlobUrl, '_blank');
    };

    const createEInvoice = () => {
        let params = { returnId: returnId, shippingListId: shippingListId, isMpReturnDispatch: true };
        ReturnCommand.CreateDocument(params)
            .then(() => {
                setIsPrintEnabled(true);
                setIsCreateEnabled(false);
            })
            .then(() => {
                Swal.fire({
                    title: t('refund.processing'),
                    html: t('refund.dispatchNoteGenerating'),
                    timer: 6000,
                    timerProgressBar: true,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                    willClose: () => {},
                });
            });
    };

    return (
        <Grid container sx={{ padding: '2rem', marginTop: 1 }} spacing={5} rowSpacing={20}>
            <Grid
                size={{
                    md: 6,
                    xs: 12,
                    lg: atDrawer ? 12 : 4,
                }}
            >
                <SCUIButton
                    type="primary"
                    sizeType="fixed"
                    text={t('refund.cargoLabel')}
                    showStartIcon
                    startIcon={<LocalPrintshopIcon style={{ color: 'white' }} />}
                    size="m"
                    fullwidth
                    onClick={() => {
                        label();
                    }}
                ></SCUIButton>
            </Grid>
            <Grid
                size={{
                    md: 6,
                    xs: 12,
                    lg: atDrawer ? 12 : 4,
                }}
            >
                <SCUIButton
                    type="primary"
                    sizeType="fixed"
                    text={t('refund.createEDispatchNote')}
                    showStartIcon
                    startIcon={<LocalPrintshopIcon style={{ color: 'white' }} />}
                    size="m"
                    onClick={() => {
                        createEInvoice();
                    }}
                    fullwidth
                    disabled={!isCreateEnabled && isPrintEnabled}
                />
            </Grid>
            <Grid
                size={{
                    md: 6,
                    xs: 12,
                    lg: atDrawer ? 12 : 4,
                }}
            >
                <SCUIButton
                    type="primary"
                    sizeType="fixed"
                    text={t('refund.printEDispatchNote')}
                    showStartIcon
                    startIcon={<LocalPrintshopIcon style={{ color: 'white' }} />}
                    size="m"
                    onClick={() => {
                        printEInvoice();
                    }}
                    fullwidth
                    disabled={!isPrintEnabled && isCreateEnabled}
                />
            </Grid>
            <Grid
                size={{
                    md: 6,
                    xs: 12,
                    lg: atDrawer ? 12 : 4,
                }}
            >
                <SCUIButton
                    text={t('refund.transferOperations')}
                    type="primary"
                    sizeType="fixed"
                    size={'m'}
                    onClick={() => {
                        window.open(other_link + '/MPPrepareReturnToSellerList ', '_blank');
                    }}
                    fullwidth
                />
            </Grid>
            <Grid
                size={{
                    md: 6,
                    xs: 12,
                    lg: atDrawer ? 12 : 4,
                }}
            >
                <br />
                <Typography variant="caption" display="block" gutterBottom color="red">
                    <b>{t('refund.clickToPrintDispatchNote')}</b>
                </Typography>

                <Typography variant="caption" display="block" gutterBottom color="red">
                    <b>{t('refund.clickToPrintLabel')}</b>
                </Typography>

                <Typography variant="caption" display="block" gutterBottom color="red">
                    <b>{t('refund.clickForOperations')}</b>
                </Typography>
            </Grid>
        </Grid>
    );
};
